// ログイン時右上に表示されるメニュー欄
import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import axios from '../axios';
import { Collapse } from 'react-bootstrap';
import { isSmartPhone } from '../BrowserJudgment';
import LoadingModal from '../molecules/LoadingModal';

const LoginInfoMenu = () => {
  const [login_info, setLoginInfo] = useState(false);
  const node = document.getElementById('header-menu');
  const user_name = node?.dataset.user_name;
  const last_login = node?.dataset.last_login;
  const is_corporate = node?.dataset.is_corporate ? true : false;
  const corporate_name = node?.dataset.corporate_name;
  const position_name = node?.dataset.position_name;
  const [is_loading, setIsLoading] = useState(false);

  // ログアウト処理
  const Logout = async () => {
    try {
      setIsLoading(true);

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/logout`);
    } catch (error) {
      console.error(error.response.data.message);
    } finally {
      //ログアウト処理の成否に関わらずマイページログイン画面に遷移する。
      location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/mypage/login`);
      setIsLoading(false);
    }
  };

  // ログインメニューの開閉(PC)
  const toggleLoginInfo = (is_open: boolean) => {
    if (isSmartPhone()) {
      return;
    }
    setLoginInfo(is_open);
  };

  // ログインメニューの開閉(SP)
  const toggleLoginInfoSP = () => {
    setLoginInfo(!login_info);
  };

  // ログインID変更ボタン
  const handleClickLoginIdChange = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/login_id/show_change_form`;
  };

  // 名前変更ボタン
  const handleClickNameChange = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/applicant/change_name`;
  };

  // マイページ利用規約ボタン
  const handleClickTermsService = () => {
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/mypage_terms_service`;
  };

  // 一般ユーザのメニュー
  const jsxStandardUserMenu = () => {
    return (
      <>
        <div className="d-flex align-items-center login-info_name">
          <div className="login-info_name_icon"></div>
          <span className="user-name">　{user_name}</span>
        </div>
        <Collapse in={login_info}>
          <div className="login-info_slide">
            <div className="sp-back">
              <div className="last-login">
                <span>前回ログイン</span>
                <span>{last_login}</span>
              </div>
              <div className="slide-content" onClick={handleClickLoginIdChange}>
                <div className="slide-content_text change-email">ログインID変更</div>
              </div>
              <div className="slide-content" onClick={handleClickNameChange}>
                <div className="slide-content_text arrow-right-small">名前変更</div>
              </div>
              <div className="slide-content" onClick={handleClickTermsService}>
                <div className="slide-content_text arrow-right-small">マイページ利用規約</div>
              </div>
              <div className="logout" onClick={() => Logout()}>
                ログアウト
              </div>
            </div>
          </div>
        </Collapse>
      </>
    );
  };

  // 法人ユーザのメニュー
  const jsxCorporateUserMenu = () => {
    return (
      <>
        <div className="d-flex align-items-center login-info_name">
          <div className="login-info_name_icon"></div>
          <span className="user-name corporate-name">{corporate_name}<br />{position_name}　{user_name}</span>
        </div>
        <Collapse in={login_info}>
          <div className="login-info_slide login-info_slide_corporate">
            <div className="sp-back">
              <div className="last-login">
                <span>前回ログイン</span>
                <span>{last_login}</span>
              </div>
              <div className="slide-content" onClick={handleClickTermsService}>
                <div className="slide-content_text arrow-right-small">マイページ利用規約</div>
              </div>
              <div className="logout" onClick={() => Logout()}>
                ログアウト
              </div>
            </div>
          </div>
        </Collapse>
      </>
    );
  };

  return (
    <div
      className="login-info"
      onMouseOver={() => toggleLoginInfo(true)}
      onMouseLeave={() => toggleLoginInfo(false)}
      onTouchEnd={toggleLoginInfoSP}
    >
      {is_corporate ? jsxCorporateUserMenu() : jsxStandardUserMenu()}
      <LoadingModal show={is_loading} />
    </div>
  );
};

if (document.getElementById('header-menu')) {
  ReactDOM.render(<LoginInfoMenu />, document.getElementById('header-menu'));
}
